var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "xinfang-baobei" }, [
    _vm.detail && _vm.jingjiren
      ? _c(
          "div",
          { staticClass: "form" },
          [
            _vm._l(_vm.personList, function (person, index) {
              return _c("div", { key: index, staticClass: "person" }, [
                _c("span", { staticClass: "content" }, [
                  _vm._v(
                    _vm._s(person.lxrlx) + ": " + _vm._s(person.login_name)
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v("联系电话: " + _vm._s(person.lxdh)),
                ]),
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "lable" }, [_vm._v("项目名称：")]),
              _vm._v(" "),
              _c("span", { staticClass: "content" }, [
                _vm._v(_vm._s(_vm.detail.xmmc)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "lable" }, [_vm._v("客户姓名：")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name",
                  },
                ],
                staticClass: "input",
                attrs: { placeholder: "请输入客户姓名" },
                domProps: { value: _vm.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.name = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "lable" }, [_vm._v("客户电话：")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phone,
                    expression: "phone",
                  },
                ],
                staticClass: "input",
                attrs: { placeholder: "请输入客户电话" },
                domProps: { value: _vm.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.phone = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "lable" }, [_vm._v("预计到访时间：")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "select", on: { click: _vm.openDatePicker } },
                [_vm._v(_vm._s(_vm.date || "请选择"))]
              ),
            ]),
            _vm._v(" "),
            _vm.jingjiren
              ? _c("div", { staticClass: "person" }, [
                  _c("span", { staticClass: "content" }, [
                    _vm._v("经纪人门店：" + _vm._s(_vm.jingjiren.dept_name)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.jingjiren
              ? _c("div", { staticClass: "person" }, [
                  _c("span", { staticClass: "content" }, [
                    _vm._v("经纪人姓名：" + _vm._s(_vm.jingjiren.login_name)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "person" }, [
              _c("span", { staticClass: "content" }, [
                _vm._v("经纪人电话：" + _vm._s(_vm.jingjirenPhone)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-commit", on: { click: _vm.commit } },
              [_vm._v("提交报备")]
            ),
            _vm._v(" "),
            _c("div", { attrs: { id: "selectDom" } }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.detail
      ? _c(
          "div",
          { staticClass: "list-wrapper" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("我的报备")]),
            _vm._v(" "),
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "item",
                  on: {
                    click: function ($event) {
                      return _vm.goToShare(item.id, item)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "xing" }, [
                    _vm._v(_vm._s(item.khxm.slice(0, 1))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "right" }, [
                    _c("div", { staticClass: "text-1" }, [
                      _vm._v(
                        _vm._s(item.khxm.slice(1)) + " " + _vm._s(item.khdh)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-2" }, [
                      _vm._v("报备时间：" + _vm._s(item.dfsj)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-3" }, [
                      _vm._v("报备项目：" + _vm._s(_vm.detail.xmmc) + " "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "status" }, [
                    _vm._v(_vm._s(item.status)),
                  ]),
                ]
              )
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }